module.exports = "<p>\n  training-approval-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Training/training-approval/training-approval-form/training-approval-form.component.html
// module id = ./src/app/hrms/Training/training-approval/training-approval-form/training-approval-form.component.html
// module chunks = main